import { render, staticRenderFns } from "./dictManage.vue?vue&type=template&id=89a3e662&scoped=true&"
import script from "./dictManage.vue?vue&type=script&lang=js&"
export * from "./dictManage.vue?vue&type=script&lang=js&"
import style0 from "./dictManage.vue?vue&type=style&index=0&id=89a3e662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a3e662",
  null
  
)

export default component.exports